export const exportAsImage = (imageUri: string, filename: string) => {
  const link = document.createElement('a');
  link.href = imageUri;
  link.download = filename;

  // Firefox requires the link to be in the body
  document.body.appendChild(link);

  // simulate click
  link.click();

  // remove the link when done
  document.body.removeChild(link);
};

export const exportAsPdf = async (imageUri: string, filename: string) => {
  const jsPDFModule = await import(
    /* webpackChunkName: "jspdf" */
    /* webpackMode: "lazy" */
    'jspdf'
  );
  let positionTop = 5;
  const pdf = new jsPDFModule.default({ orientation: 'landscape' });
  const imgProps = pdf.getImageProperties(imageUri);
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  let heightLeft = pdfHeight;
  pdf.addImage(imageUri, 'PNG', 0, positionTop, pdfWidth, pdfHeight);
  heightLeft -= pageHeight;
  while (heightLeft >= 0) {
    positionTop += heightLeft - pdfHeight; // top padding for other pages
    pdf.addPage();
    pdf.addImage(imageUri, 'PNG', 0, positionTop, pdfWidth, pdfHeight);
    heightLeft -= pageHeight;
  }
  pdf.save(filename);
};

export const BALANCE_TABLE_ROOT_ELEMENT = 'balanceTableRoot';
export const EXPORT_REF_ID = 'dashboardRoot';
